import React, { createContext, useContext, useState, useEffect } from 'react';
import DonationOverlay from './DonationOverlay';

export const DonationContext = createContext();

export function DonationProvider({
  donationVisible,
  toggleDonationForm,
  children,
}) {
  const value = { donationVisible, toggleDonationForm };
  const [mounted, setMounted] = useState(false);

  // after component mounts
  useEffect(() => {
    setMounted(true);
  }, []);
  return (
    <DonationContext.Provider value={value}>
      {children}
      {mounted && (
        <DonationOverlay
          isVisible={donationVisible}
          onClose={() => toggleDonationForm(false)}
        />
      )}
    </DonationContext.Provider>
  );
}

export function useDonation() {
  return useContext(DonationContext);
}
